import type { FetchFunction } from '#layers/base/public';
import { withItemType } from '@rstore/vue';
import * as z from 'zod/v4-mini';
import { SINGLETON_KEY } from '#layers/base/public';

const WorkspaceInfoResult = z.object({
	ai: z.object({
		enabled: z.boolean(),
	}),
});

/** The engine's `/info` probe for one workspace. */
export type WorkspaceInfo = z.infer<typeof WorkspaceInfoResult>;

/** `/info` is not an `/items` resource and answers unenveloped, so the read bypasses the monospace plugin. */
export function createWorkspaceInfo(workspaceFetch: FetchFunction) {
	return withItemType<WorkspaceInfo>().defineCollection({
		name: 'WorkspaceInfo',
		getKey: () => SINGLETON_KEY,
		meta: {
			singleton: true,
		},
		hooks: {
			fetchFirst: async () => WorkspaceInfoResult.parse(await workspaceFetch('/info')),
		},
	});
}
